import * as actionTypes from "../actions/actionTypes";

const initialState = {
  commonData: {
    estadoCivil: [],
    profesiones: [],
    estudios: [],
    tipoVivienda: [],
    ok: false,
  },
  errorMsg: "",
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_SET_COMMON_DATA: {
      return {
        ...state,
        errorMsg: "",
        loading: true,
      };
    }
    case actionTypes.SET_COMMON_DATA: {
      return {
        commonData: action.commonData,
        errorMsg: "",
        loading: false,
      };
    }
    case actionTypes.SET_COMMON_DATA_FAILED: {
      return {
        commonData: {
          ...state.commonData,
          ok: false,
        },
        errorMsg: action.errorMsg,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;
